export const LANGUAGES_TRANS: { [key: string]: string } = {
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
  it: 'Italiano'
};
